/**
 * Created by koqiui on 2017-04-09.
 */
import {Utils, Jqext} from '../../app.base'
import {Vue, MsgBox} from '../../app.vues';

let Toast = Jqext.Toast;

//
import SwbPubAgreement from './PubAgreement';
import SwbRegistPubAgreement from './RegistPubAgreement';
import SwbPrivacyPubAgreement from './PrivacyPubAgreement';
import SwbBigImg from './BigImg';

Vue.regist(SwbPubAgreement);
Vue.regist(SwbRegistPubAgreement);
Vue.regist(SwbPrivacyPubAgreement);
Vue.regist(SwbBigImg);

/**
 * 公开协议-查看
 * @param code
 * @param title
 */
export function openPubAgreementDlg(title, code) {
    title = title || '查看协议';
    Vue.$showDialog({
        title: title,
        showCloseBtn: true,
        width: '70%',
        height: '70%',
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-pub-agreement :code="code" ref="swb_pub_agreement"></swb-pub-agreement>',
        data: {
            code: code
        },
        okClicked: function () {
        },
        lifecycle: {},
    });
}

/**
 * 查看-注册协议
 * @param title
 */
export function openRegistPubAgreementDlg(title) {
    title = title || '查看协议';
    Vue.$showDialog({
        title: title,
        showCloseBtn: true,
        width: '70%',
        height: '70%',
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-regist-pub-agreement ref="swb_regist_pub_agreement"></swb-regist-pub-agreement>',
        data: {},
        okClicked: function () {
        },
        lifecycle: {},
    });
}

/**
 * 查看-隐私政策-【注册时】
 * @param title
 */
export function openPrivacyPubAgreementDlg(title) {
    title = title || '查看协议';
    Vue.$showDialog({
        title: title,
        showCloseBtn: true,
        width: '70%',
        height: '70%',
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-privacy-pub-agreement ref="swb_privacy_pub_agreement"></swb-privacy-pub-agreement>',
        data: {},
        okClicked: function () {
        },
        lifecycle: {},
    });
}

/**查看大图*/
export function openBigImgDlg(imgSrc) {
    let theDlg = Vue.$showDialog({
        title: '图片查看',
        showCloseBtn: true,
        width: '90%',
        height: '100%',
        okVisible: false,
        cancelVisible: false,
        template: '<div style="height: 100%;" @click="clickit"><swb-big-img :imgSrc="imgSrc" ref="swb_big_img"></swb-big-img></div>',
        data: {
            imgSrc: imgSrc
        },
        methods: {
            clickit() {
                theDlg.close();
            }
        }
    });
}

import SwbHelpArticleInfoShow from './HelpArticleInfoShow'

Vue.regist(SwbHelpArticleInfoShow);

// 查看文章帮助
export function openHelpArticleInfoShowDlg(code) {
    Vue.$showDialog({
        title: "文章帮助",
        width: '70%',
        height: '70%',
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-help-article-info-show :code="code" ref="swb_help_article_info_show"></swb-help-article-info-show>',
        data: {
            code: code
        },
        okClicked: function () {
        },
    });
}

import SwbUserManualShow from './UserManualShow'

Vue.regist(SwbUserManualShow);

export function openUserManualInfoDlg(manualId) {
    Vue.$showDialog({
        title: "用户手册-查看",
        width: '70%',
        height: '70%',
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-user-manual-info-show :manualId="manualId" ref="swb_user_manual_info_show"></swb-user-manual-info-show>',
        data: {
            manualId: manualId
        },
        okClicked: function () {
        },
    });
}

import SwbFinacBizTypeListForSelect from './FinacBizTypeListForSelect'

Vue.regist(SwbFinacBizTypeListForSelect);

/** 财务类型通用选择 */
export function selectFinacBizTypeDlg(params, callbackFunc) {
    let checkBox = params['checkBox'] || false;
    let selectIds = params['selectIds'] || [];
    let theDlg = Vue.$showDialog({
        title: "财务业务类型-选择",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-finac-biz-type-list-select :checkBox="checkBox" :selectIds="selectIds" ref="swb_finac_biz_type_list_select"></swb-finac-biz-type-list-select>',
        data: {
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_finac_biz_type_list_select.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}

import SwbRealComListSelect from './RealComListSelect'

Vue.regist(SwbRealComListSelect);

/** 实体公司通用选择 */
export function selectRealComDlg(params, callbackFunc) {

    let theDlg = Vue.$showDialog({
        title: "实体公司-选择",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-real-com-list-select :disabledIds="disabledIds" ref="swb_real_com_select"></swb-real-com-list-select>',
        data: {
            disabledIds: params['disabledIds'] || null,
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_real_com_select.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}

import SwbRetailerRealComListSelect from './RetailerRealComListSelect'

Vue.regist(SwbRetailerRealComListSelect);

/** 零售商实体公司通用选择 */
export function selectRetailerRealComDlg(params, callbackFunc) {
    let theDlg = Vue.$showDialog({
        title: "实体公司-选择",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-retailer-real-com-list-select :realMerchantId="realMerchantId" :bizUnitId="bizUnitId" ref="swb_retailer_real_com_select"></swb-retailer-real-com-list-select>',
        data: {
            realMerchantId: params['realMerchantId'] || null,
            bizUnitId: params['bizUnitId'] || null,
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_retailer_real_com_select.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}

import SwbCustTaxPayTypeListForSelect from './CustTaxPayTypeListForSelect'

Vue.regist(SwbCustTaxPayTypeListForSelect);

/** 自定义纳税类型通用选择 */
export function selectCustTaxPayTypeDlg(params, callbackFunc) {
    let checkBox = params['checkBox'] || false;
    let selectStdValues = params['selectStdValues'] || [];
    let theDlg = Vue.$showDialog({
        title: "财务业务类型-选择",
        width: 1300,
        height: 800,
        showCloseBtn: true,
        template: '<swb-cust-tax-pay-list-for-select :checkBox="checkBox" :selectStdValues="selectStdValues" ref="swb_cust_tax_pay_list_for_select"></swb-cust-tax-pay-list-for-select>',
        data: {
            checkBox: checkBox,
            selectStdValues: selectStdValues
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_cust_tax_pay_list_for_select.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}

import SwbCustTaxPayTypeSave from './CustTaxPayTypeSave'

Vue.regist(SwbCustTaxPayTypeSave);

/** 自定义纳税类型保存 */
export function openCustTaxPayTypeSaveDlg(params, callbackFunc) {
    let id = params['id'] || null;
    let theDlg = Vue.$showDialog({
        title: "纳税类型-保存",
        width: 700,
        height: 600,
        showCloseBtn: true,
        template: '<swb-cust-tax-pay-type-save :id="id"  ref="swb_cust_tax_pay_type_save"></swb-cust-tax-pay-type-save>',
        data: {
            id: id,
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_cust_tax_pay_type_save.getDlgResult() || {};
            if (dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
            return false;
        }
    });
}

import SwbCustTaxPayTypeShow from './CustTaxPayTypeShow'

Vue.regist(SwbCustTaxPayTypeShow);

/** 自定义纳税类型保存 */
export function openCustTaxPayTypeShowDlg(params, callbackFunc) {
    let id = params['id'] || false;
    let theDlg = Vue.$showDialog({
        title: "纳税类型-查看",
        width: 700,
        height: 600,
        showCloseBtn: true,
        template: '<swb-cust-tax-pay-type-show :id="id"  ref="swb_cust_tax_pay_type_show"></swb-cust-tax-pay-type-show>',
        data: {
            id: id,
        },
        okClicked: function () {
        }
    });
}

import swbFileUploadGroup from './FileUploadGroupDlg'

Vue.regist(swbFileUploadGroup);

/** 通用文件导入 */
export function fileUploadGroupShowDlg(uploadParams, downloadUrl, callback, downloadFunc) {
    uploadParams = uploadParams == null ? {} : uploadParams;
    //
    let title = uploadParams.title == null ? "文件导入" : uploadParams.title;
    let theDlg = Vue.$showDialog({
        title: title,
        width: 700,
        height: 600,
        showCloseBtn: true,
        cancelText: "关闭",
        okVisible: false,
        template: '<swb-file-upload-group :custFileds="custFileds" :fileGroup = "fileGroup" :multipleFile="multipleFile" :downloadUrl="downloadUrl" :downloadFunc="downloadFunc" :showFormatElpx="showFormatElpx" @notity-upload-done ="onUploadDone($event)"></swb-file-upload-group>',
        data: {
            fileGroup: uploadParams.fileGroup || null,
            multipleFile: uploadParams.multipleFile || false,
            showFormatElpx: uploadParams.showFormatElpx,
            custFileds: uploadParams.custFileds || null,
            downloadUrl: downloadUrl,
            downloadFunc: downloadFunc
        },
        methods: {
            onUploadDone: function (result) {
                callback(result, theDlg);
            }
        },
        okClicked: function () {
        }

    });
}


// 历史记录查询 对话框----------------------------
import merchtComn from '../../api/merchtComn';
import SwbHisRecordsView from './HisRecordsView.vue';
import comnApi from '../../api/comn'

//config {title, confId, confName, excludedCtxNames, }
export function showHisRecordsViewDlg(config) {
    Vue.regist(SwbHisRecordsView);
    //
    config = config || {};

    let confId = config['confId'] || -1;
    if (confId == null || confId < 0) {
        Toast.show('未指定要查询的配置id', 5000, 'warning');
        return;
    }

    let confName = config['confName'] || '未知';
    let title = config['title'] || '历史记录查询 - ' + confName;
    let excludedCtxNames = config['excludedCtxNames'] || [];

    merchtComn.getHisMetaQueryResultConfById(confId, function (result) {
        if (!result.success) {
            Toast.show('获取历史查询配置失败：' + result.message, 5000, 'error');
        } else if (result.data == null) {
            Toast.show('获取历史查询配置失败：没有配置内容', 5000, 'warning');
        } else {
            let confInfo = result.data;
            let queryTable = confInfo['targetTable'] || null;
            //查询配置
            let queryFields = confInfo['queryFields'] || [];
            if (typeof queryFields == 'string') {
                queryFields = JSON.decode(queryFields);
            }
            let sortFields = confInfo['sortFields'] || [];
            if (typeof sortFields == 'string') {
                sortFields = JSON.decode(sortFields);
            }
            let queryConfig = {
                queryFields: queryFields,
                sortFields: sortFields
            }

            //结果配置
            let colList = confInfo['colList'] || [];
            if (typeof colList == 'string') {
                colList = JSON.decode(colList);
            }
            let resultConfig = {
                colList: colList
            };

            //
            Vue.$showDialog({
                title: title,
                showCloseBtn: true,
                width: -100,
                height: -40,
                okVisible: false,
                cancelVisible: false,
                template: '<swb-his-records-view :style="{width : contentWidth, height : contentHeight}" ref="his-records-ctrl" :excludedCtxNames="excludedCtxNames" :query-table="queryTable" :query-config="queryConfig" :result-config="resultConfig" :result-fetcher="resultFetcher"></swb-his-records-view>',
                data: {
                    queryTable: queryTable,
                    queryConfig: queryConfig,
                    resultConfig: resultConfig,
                    excludedCtxNames: excludedCtxNames,
                    //
                    contentWidth: '100%',
                    contentHeight: '100%'
                },
                methods: {
                    dlgBodyResized(width, height) {
                        this.contentWidth = width;
                        this.contentHeight = height;
                    },
                    resultFetcher(requestData, callback) {
                        let loader = MsgBox.loading('正在查询历史记录...');
                        comnApi.queryHisRecords(requestData, function (result) {
                            loader.hide();
                            //
                            callback(result);
                        });
                    }
                }
            });
        }
    });
}

export function createTaskExportDlg(asynTaskInfo, callback) {
    let theDlg = Vue.$showDialog({
        title: "执行导出任务",
        width: 600,
        height: 300,
        showCloseBtn: true,
        template: '<div class="simple-form">' +
            '   <div class="form-group center">' +
            '        <div class="form-label">' +
            '            <label class="required">导出任务标题</label>' +
            '        </div>' +
            '        <div class="form-value width-2x">' +
            '            <el-input placeholder="请输入任务标题" v-model="title"></el-input>' +
            '        </div>' +
            '   </div>' +
            '   <div class="input-tip error">您所导出的数据较多，烦请您耐心等待，等待时间不影响您执行其他工作，系统处理完成会主动提醒您在“查看结果文件”下载！</div>' +
            '</div>',
        data: {
            title: null
        },
        okClicked: function () {
            let title = this.title;
            if (Utils.isNoB(title)) {
                Toast.show("请输入任务标题！");
                return false;
            } else {
                title = title.trim();
                if (title.length == 0) {
                    Toast.show("请输入任务标题！");
                    return false;
                } else if (title.length > 45) {
                    Toast.show("任务标题最长45个字符,现" + title.length + "个");
                    return false;
                }
            }
            this.title = title;
            asynTaskInfo.title = title;
            let theLoad = MsgBox.loading();
            comnApi.saveAsynTaskInfo(asynTaskInfo, function (result) {
                theLoad.hide();
                if (result.type === "info") {
                    theDlg.close();
                    callback();
                } else {
                    MsgBox.warning(result.message);
                }
            });
            return false;
        }
    });
}

import AsynTaskInfoList from './AsynTaskInfoList';
Vue.regist(AsynTaskInfoList);
export function viewTaskExportListDlg(params) {
    Vue.$showDialog({
        title: "查看结果文件",
        width: 1000,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-asyn-task-info-list :params="params"></swb-asyn-task-info-list>',
        data: {
            params: params
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/comn/dialog.js
// module id = 28
// module chunks = 1